import {
  useState, useEffect, useCallback,
} from 'react';
import DT from 'duration-time-conversion';

export default function useCurrentItemIndex(items, currentTime, setCurrentTime, startTimeKey = 'startTime', endTimeKey = 'endTime') {
  const [activeItemIndex, setActiveItemIndex] = useState(-1);
  const [manualChange, setManualChange] = useState(null);

  useEffect(() => {
    if (manualChange && activeItemIndex !== -1) {
      return;
    }

    const indexes = items.map((item, i) => {
      const start = DT.t2d(item[startTimeKey]);
      const end = DT.t2d(item[endTimeKey]);
      if (currentTime >= start && currentTime <= end) return i;
      return null;
    }).filter((i) => i !== null);

    /** Last index is the active index */
    const index = indexes.length ? indexes[indexes.length - 1] : -1;

    if (index !== activeItemIndex) setActiveItemIndex(index);
  }, [activeItemIndex, currentTime, endTimeKey, items, manualChange, startTimeKey]);

  useEffect(() => {
    if (manualChange) {
      const [start, end] = manualChange;
      if (currentTime < DT.t2d(start) || currentTime > DT.t2d(end)) {
        setManualChange(null);
      }
    }
  }, [currentTime, manualChange]);

  const setTime = useCallback((time, range) => {
    setCurrentTime(time);

    if (range[0] && range[1]) {
      /** If range is correct set active item by range */
      setManualChange(range);
      const index = items.findIndex((item) => {
        const start = item[startTimeKey];
        const end = item[endTimeKey];
        return start === range[0] && end === range[1];
      });
      setActiveItemIndex(index);
    }
  }, [endTimeKey, items, setCurrentTime, startTimeKey]);

  return [activeItemIndex, setTime];
}
